export default {"src":"/_next/static/media/tickButton.c92822f4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};